module.exports = __webpack_public_path__ + "media/images/gallery/constellations/andromeda/and_dn-26ff573e73299c9d49eb1d56a6a3b70c.gif";